var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"product__highlights list-inside leading-relaxed pl-2"},_vm._l((_vm.value),function(highlight){return _c('li',{key:highlight},[_vm._v("\n    "+_vm._s(highlight)+"\n  ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }